import React from 'react';
import { NextPage } from 'next';
import { getInitialPropsBasicDeal } from '@utils/getInitialProps/getInitialPropsBasicDeal';
import { SSRError } from '@components/SSRError';
import { ContextWithStore } from '@utils/getInitialProps/@types';
import { Basket } from '@components/v2/Basket';
import { useUserDuck } from '@hooks/useUserDuck';

interface IBasketPage {
    statusCode?: number;
}

const BasketPage: NextPage<IBasketPage> = ({ statusCode }) => {
    if (!statusCode || statusCode > 201) return <SSRError statusCode={statusCode} />;

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { isUserLoggedInAsDealer } = useUserDuck();

    return <Basket isUserLoggedInAsDealer={isUserLoggedInAsDealer} />;
};

BasketPage.getInitialProps = async (ctx: ContextWithStore) => getInitialPropsBasicDeal(ctx, true);

export default BasketPage;
